module.exports = __webpack_public_path__ + "static/media/basis-grotesque-regular.88e2184e.ttf";